import { useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { DashboardManagedByResponseDto } from '@/features/dashboard/types/dashboard-dto';
import { ApiHookProps } from '@/@types/api.types';
import { useDashboardFilter } from '@/features/dashboard/hooks/useDashboardFilter';
import { UrlHelper } from '@/utils/UrlHelper';
import { DateTimeHelper } from '@/utils/dateTimeHelper';
import {useAxiosAuth} from "@/hooks/useAxiosAuth.ts";

export const useDashboardManagedByApi = () => {
  const axiosInstance = useAxiosAuth();
  const { filter } = useDashboardFilter();
  const { startDate, endDate, apartmentId } = filter;

  const apartmentIds = apartmentId?.map((apartment) => apartment.id);

  const {
    data: managedByData, 
    isLoading: isLoadingManagedByData, 
    isError: isErrorManagedByData
  } = useQuery({
    queryKey: [
        ApiConfig.queries.features.dashboard.queryKeys.managedBy,
        startDate, endDate, apartmentId
    ],
    queryFn: async () => {
      const url = UrlHelper.buildUrlWithQueryParams(ApiConfig.queries.features.dashboard.endpoints.managedBy, {
        startDate: DateTimeHelper.getDateOnly(startDate),
        endDate: DateTimeHelper.getDateOnly(endDate),
        apartmentId: apartmentIds
      });        
      const { data } = await axiosInstance.get<DashboardManagedByResponseDto>(url);
      return data;
    },
  });

  return {
    managedByData, 
    isLoadingManagedByData, 
    isErrorManagedByData,
  }
};